<template>
  <v-container fluid grid-list-md class="grey lighten-5 ma-2" >
    <v-row>
      <v-flex xs12 sm12 md8 lg8 ex8>
        <v-card ref="form">
          <v-card-text>
              <v-row no-gutters>
                <v-flex xs="12" class="py-0 px-2">                
                    <h2>Usklada knjiga i inf.posrednika</h2>
                </v-flex>
              </v-row>

              <v-row no-gutters>
                <v-col xs="4" class="py-0 px-2">
                    {{lang.CompanyName}}
                </v-col>
                <v-col xs="4" class="py-0 px-2">
                    <span style="font-weight:bold">{{mainledgerAna.CompanyNameDatabase}}</span>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col xs="4" class="py-0 px-2">
                    {{lang.BusinessYear}}
                </v-col>
                <v-col xs="4" class="py-0 px-2">
                    <span style="font-weight:bold">{{ parseInt(mainledgerAna.BusinessYear) || '' }}</span>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col xs="4" class="py-0 px-2">
                  {{lang.User}}
                </v-col>
                <v-col xs="8" class="py-0 px-2">
                    <span style="font-weight:bold">{{mainledgerAna.First}} {{mainledgerAna.Last}}, {{mainledgerAna.email}}, {{mainledgerAna.UserId}}</span>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <br>

          <v-row>
            <v-col xs="2" >
                Max.period 1 mjesec
            </v-col>
              <v-col xs="2" >
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal1"
                  width="290px"
                  :return-value.sync="startDate"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatDate1"
                      :label="langC.FromDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
          
                    ></v-text-field>
                  </template>

                  <v-date-picker v-model="startDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modal1 = false">Cancel</v-btn>
                    <v-btn color="primary" @click="$refs.dialog1.save(startDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col xs="2" >
                <v-dialog
                  ref="dialog2"
                  persistent
                  v-model="modal2"
                  width="290px"
                  :return-value.sync="endDate"
                >
                 <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatDate2"
                      :label="langC.ToDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
 
                  <v-date-picker v-model="endDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modal2 = false">Cancel</v-btn>
                    <v-btn color="primary" @click="$refs.dialog2.save(endDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

               <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2"  >
                  <v-select
                  v-model="selectedMonth"
                  :items="months"
                  label="Mjesec"
                  clearable
                ></v-select>
              </v-col>
              <v-col xs="2" >
                <v-btn
                    color="blue"
                    :disabled="!formIsValid"
                    @click="loadEinvoices()">
                    {{lang.LoadFromInt}}
                </v-btn>
              </v-col>
          </v-row>           

          
          </v-card-text>
          <v-divider class="mt-1 mb-3"></v-divider>
          <v-card-actions>


          </v-card-actions>
        </v-card>
      </v-flex>

    </v-row>

    <v-progress-linear v-if="saving"
      indeterminate
      color="blue"
      class="mt-5"
    ></v-progress-linear>

    <v-row v-if="showCard1">
      <MainLedgerBooksList :items="items" :total="total" @myEvent="myMethod" @myEvent2="myMethod2"/>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      bottom
      :color="color"
      >
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>

import dayjs from 'dayjs'
import { dohvatiSifrarnik, spojiStavku } from '@/snippets/spojiSaSifrarnikom'
import Api from '@/services/Api'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import MainLedgerBooksList from './MainLedgerBooksList'
import PondiService from '@/services/PondiService'
import merService from '@/services/merService'
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'
import { defMainLedger, defNew, defMainQuery,defNewpartner, defMainLedgerDetail, defMainLedgerDetailFill } from './mainledgerHelper'
import { round, parseNum, dynamicSort, doZeros } from '@/snippets/allSnippets'
import { testLastUpdate, newUpdates } from '@/services/TestLastUpdate'
import {defBankOrder, defNewBankOrder} from '../Salarie/salarieHelper'
import BankOrderService from '@/services/BankOrderService'
import BankAccountService from '@/services/BankAccountService'
import {nacinIzSifre, vecPodmiren} from './nacinPlacanja'
import PartnerService from '@/services/PartnerService'
import PartnerCompanyService from '@/services/PartnerCompanyService'
import { defDocument,defDocumentDetail,defNewDocumentDetail} from '@/components/Document/documentHelper'
import { domacaValuta, tecajValute, uKunama } from '@/snippets/domacaValuta'

export default {
  name: 'mainledgerbooks',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      virmanBanka: null,
      virmaniPostojeci: null,
      virmaniKreirani: 0,
      virmaniPreskoceni: [],
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date1: null,
      date2: null,
      msg: '',
      valid: true,
      startDate: null,
      endDate: null,
      mainledgerAna: {
        CompanyId: 0,
        CompanyNameDatabase: '',
        BusinessYear: 0,
        UserId: 0,
        email: '',
        First: '',
        Last: '',
        fromDate: null,
        toDate: null,
        fromAccount: '',
        toAccount: ''
      },
      comp: {},
      error: null,
      localError: false,
      size: 'sm',
      account4Loc: [],
      account4LocFrom: [],
      account4LocTo: [],
      partners: [],
      items: [],
      items4: [],
      items6: [],
      items9: [],
      psItems: [],
      CompanyId: 0,
      selectPa: {},
      selectA4: {},
      selectA4from: {},
      selectA4to: {},
      selectUs3: {},
      mainQuery: {},
      havePath: '',
      PrintDate: null,
      lang: {},
      langC: {},
      saving: false,
      showCard1: false,
      showCard2: false,
      showCard3: false,
      showCard4: false,
      showCard5: false,
      showCard6: false,
      showCard9: false,
      showCard10: false,
      bookType: [],
      bookTypeSelected: {
      },
      bookTypeSelectedName: 'TEM',
      sameAsFrom: false,
      total: 0,
      fTotal2: 0,
      fTotal3: 0,
      fTotal4: 0,
      fTotal5: 0,
      ffTotal1: 0,
      ffTotal2: 0,
      ffTotal3: 0,
      ffTotal4: 0,
      ffTotal5: 0,
      projectTypes: [],
      selectPT: {},
      newItem: {},
      newItems: [],
      exRate: this.$store.getters.NeedDefExRate,
      exRate2: 1,
      totalsNine: {},
      finishYear: false,
      finishYearDesc: '',
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
      selectedMonth: null,
      showEUR: true,
      displayEURselector: false,
      pItems: [],
      allItems: [],
      fullAdmin: false,
      bookItems: [],
      locBookID: null,
      doc: {},
      mainledger: {},
      document: {},
      documentDet: {},
      activItems: [],
      partId: null
    }
  },
  components: {
    MainLedgerBooksList
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr;
    }

    this.$store.dispatch('setTikTok', 0)
   
    // need five arrays with partners, employes, tasktype, taskdepartment, users
    if (this.$store.state.companyid) {
      this.CompanyId = this.$store.state.companyid
      this.mainledgerAna.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
    }

    this.showEUR = uKunama(this.$store.state.businessYear)
    
    this.comp = this.$store.state.companyActiv
    if (this.CompanyId > 0) {
      //await checkPartners(0)
      await testLastUpdate()
      if (this.$store.state.partnerStore) {
        this.partners = this.$store.state.partnerStore
      }
    }
    if (this.$store.state.user.id) {
      this.mainledgerAna.UserId = this.$store.state.user.id
    }
    if (this.$store.state.user.email) {
      this.mainledgerAna.email = this.$store.state.user.email
    }
    if (this.$store.state.user.First) {
      this.mainledgerAna.First = this.$store.state.user.First
    }
    if (this.$store.state.user.Last) {
      this.mainledgerAna.Last = this.$store.state.user.Last
    }
    this.mainledgerAna.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 1
    this.mainledgerAna.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : null
    this.mainledgerAna.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2022
    this.displayEURselector = uKunama(this.$store.state.businessYear)
    this.finishYearDesc = this.lang.FinishYear + this.mainledgerAna.BusinessYear

    let locDate1 = new Date()
    this.PrintDate = dayjs().format('DD.MM.YYYY, H:mm')
    
    this.startDate = dayjs([this.mainledgerAna.BusinessYear]).startOf('month').format('YYYY-MM-DD')
    this.endDate = dayjs([this.mainledgerAna.BusinessYear]).endOf('month').format('YYYY-MM-DD')
    locDate1.getDate()
    locDate1.getMonth() + 1
    locDate1.getFullYear()

  },
  computed: {
    formIsValid () {
      return this.startDate !== null &&
        this.endDate !== null &&
        this.mainledgerAna.CompanyId !== ''
    },
    formatDate1() {
      return this.startDate
        ? dateFormat(this.startDate)
        : "";
    },
    formatDate2() {
      return this.endDate
        ? dateFormat(this.endDate)
        : "";
    },
  },
  methods: {
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    // create receipt purchase from xml

    async myMethod2(param) {
      try {
        this.saving = true
        console.log('param', param)
        for (var member in this.doc) delete this.doc[member];
        this.locBookID = param

        const query = {
          id: param,
          pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : '',
          companyId:  this.$store.state.companyid ? this.$store.state.companyid : 1,
          businessYear: this.$store.state.businessYear ? this.$store.state.businessYear : 2026,
          newId: this.getRndInteger(1000000000, 9000000000),
          notSaveDoc: true
        }
        const res = await PondiService.getxml(query)
        console.log('res', res)
        this.doc = res && res.data && res.data.invoice ? res.data.invoice : null
        if (Object.keys(this.doc).length > 0) {
          console.log('this.doc', this.doc)
          // create new Document
          await this.newGoods()
          // update items with connected document

          // const nema = false
          // if (this.items && this.items.length > 0) {
          //     this.items = this.items.map(item => {
          //       if (item.id === param) {
          //         return { ...item, 
          //           inBooks: true,
          //           BookID: this.mainledger.BookID,
          //           BookName: this.mainledger.BookName,
          //           BookingDate: this.mainledger.BookingDate,
          //           email: this.mainledger.email
          //          };
          //       }
          //       return item;
          //     });
          // }
          const newTikTok = this.$store.state.tikTok + 1
          this.$store.dispatch('setTikTok', newTikTok)
        }
        if (Object.keys(this.doc).length === 0){
          alert('Error! Something is wrong with load data!')
        }
        this.saving = false
      } catch (error) {
        this.saving = false
        console.log('error', error)
        alert(error)
      }
    },
    async newGoodsDetails() {
        this.activItems.length = 0
        // Sifrarnik se dohvaca jednom za cijelu primku.
        const sifrarnik = await dohvatiSifrarnik(this.$store.state.companyid)
        if (this.doc && this.doc.stavke && this.doc.stavke.length > 0) {
          console.log('this.doc.stavke: ', this.doc.stavke);
          this.doc.stavke.map(st => {
            this.documentDet = defDocumentDetail()
            this.documentDet = {...this.documentDet, ...defNewDocumentDetail()}
            const newId = this.getRndInteger(1000000000, 9000000000)

            const cijena = parseNum(st.cijena,2)
            const kolicina = parseNum(st.kolicina,2)
            const netoIznos = parseNum(st.netoIznos,2)
            const poreznaStopa = parseNum(st.poreznaStopa,2)

            this.documentDet.itemName = st.opis ? st.opis : ''
            this.documentDet.ItemSuppCode = st?.sifraDob ?? ''
            this.documentDet.ItemEANCode =st?.barcode ?? ''
            this.documentDet.itemPcsPlus = kolicina
            this.documentDet.itemSuppBasePrice = cijena
            this.documentDet.itemSuppDiscount = 0
            this.documentDet.itemSuppBasePriceAmount  = netoIznos
            this.documentDet.itemSuppPriceAmount = netoIznos
            this.documentDet.itemSuppDiscountAmount = 0
            this.documentDet.itemSuppPrice = cijena
            this.documentDet.itemPrice = cijena
            this.documentDet.itemVAT1Percentage = poreznaStopa
            this.documentDet.itemBaseAmount = netoIznos
            this.documentDet.itemBaseForeAmount = netoIznos
            this.documentDet.itemBaseAmountNoVAT = netoIznos
            this.documentDet.itemBaseForeAmountNoVAT = netoIznos
            const total = round((netoIznos * (1 + (poreznaStopa /100))),2)
            this.documentDet.itemVAT1Amount = total - netoIznos
            this.documentDet.itemBaseAmountWithVAT = total
            this.documentDet.itemBaseForeAmountWithVAT = total
            this.documentDet.itemAmountWithVAT = total
            this.documentDet.itemFullTotal = total
            this.documentDet.itemPriceWithVAT = kolicina != 0 ? round((total / kolicina),2) : 0
            this.documentDet.itemVAT1Amount = round((total - netoIznos),2)
            this.documentDet.ExRate = 1
            this.documentDet.partnerId = this.document?.partnerId ?? ''
            this.documentDet.partnerNameDatabase =  this.document?.partnerNameDatabase ?? ''

            this.documentDet.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
            this.documentDet.email = this.$store.state.user.email ? this.$store.state.user.email : 'test@cegrupa.com'
            this.documentDet.First = this.$store.state.user.First ? this.$store.state.user.First : 'NoFirst'
            this.documentDet.Last = this.$store.state.user.Last ? this.$store.state.user.Last : 'NoLast'
            this.documentDet.uservatID = this.$store.state.user.vatID ? this.$store.state.user.vatID : '12345678901'
            this.documentDet.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
            this.documentDet.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
            this.documentDet.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024

            // Ako sifra dobavljaca s racuna postoji u sifrarniku, stavka odmah
            // dobiva lokalnu sifru i prodajnu cijenu; inace ostaje kakva je bila.
            spojiStavku(this.documentDet, sifrarnik)

            this.activItems.push(this.documentDet)
          })
          
          // cijena"3.95"
          // kolicina"5.000"
          // netoIznos"19.75"
          // opis"PAPIR FORoffice A4 80gr. 500/1"
          // poreznaOznaka"S"
          // poreznaStopa"25"
        }
    },
    makeSum() {
      const updateSumObject = {
        documentDescription9: 0,
        documentDescription10: 0,
        documentTotalVAT1Per: 0,
        documentTotalVAT1Base: 0,
        documentTotalVAT1Amount: 0,
        documentTotalVAT2Per: 0,
        documentTotalVAT2Base: 0,
        documentTotalVAT2Amount: 0,
        documentTotalVAT3Per: 0,
        documentTotalVAT3Base: 0,
        documentTotalVAT3Amount: 0,
        documentTotalVAT4Per: 0,
        documentTotalVAT4Base: 0,
        documentTotalVAT4Amount: 0,
        documentTotalVAT5Per: 0,
        documentTotalVAT5Base: 0,
        documentTotalVAT5Amount: 0,
        documentTotalAmountNetto: 0,
        documentTotalAmountVAT: 0,
        documentTotalAmountBrutto: 0,
        documentTotalAmountPayInAdvance: this.$store.state.documentActivHead.documentTotalAmountPayInAdvance ? parseFloat(this.$store.state.documentActivHead.documentTotalAmountPayInAdvance) : 0,
        documentTotalAmountToPay: 0,
        documentTotalAmountNettoForeign: 0,
        documentTotalAmountVATForeign: 0,
        documentTotalAmountBruttoForeign: 0,
        documentTotalAmountPayInAdvanceForeign: 0,
        documentTotalAmountToPayForeign: 0,
        documentTotalAmountDirectD1: 0,
        documentTotalAmountDirectD2: 0,
        documentTotalAmountDirectD1Fore: 0,
        documentTotalAmountDirectD2Fore: 0,
        supplierAmount: 0,
        supplierNetoAmount: 0,
        supplierDiscount: 0,
        supplierMargin: 0,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
        ExRate: 1
      }
      let dSide = 3
      if (this.$store.state.documentSide) {
        dSide = this.$store.state.documentSide
      }

      const hrVat1 = 25
      const hrVat2 = 13
      const hrVat3 = 5

      if (this.activItems) {
        this.activItems.map(documentDet => {
          
          if ((documentDet.itemSuppBasePriceAmount)) {
            updateSumObject.supplierAmount += round((documentDet.itemSuppBasePriceAmount),2)
          }
          if (documentDet.itemSuppDiscountAmount) {
            updateSumObject.supplierDiscount += round(documentDet.itemSuppDiscountAmount,2)
          }
          if (documentDet.itemSuppPriceAmount) {
            updateSumObject.supplierNetoAmount += round(documentDet.itemSuppPriceAmount,2)
          }
          if (documentDet.itemBaseAmount) {
            updateSumObject.documentDescription9 += parseFloat(documentDet.itemBaseAmount)
          }
          if (documentDet.itemBaseAmountNoVAT) {
            updateSumObject.documentTotalAmountNetto += parseFloat(documentDet.itemBaseAmountNoVAT)
          }
          // if (documentDet.itemVAT1Amount) {
          //   updateSumObject.documentTotalAmountVAT += parseFloat(documentDet.itemVAT1Amount)
          // }
          //const dD1 = documentDet.itemDirectDuty1Amount ? parseFloat(documentDet.itemDirectDuty1Amount) : 0
          // if (documentDet.itemAmountWithVAT) {
          //   updateSumObject.documentTotalAmountBrutto += parseFloat(documentDet.itemAmountWithVAT) + dD1
          // }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat1) {
            updateSumObject.documentTotalVAT1Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT1Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT1Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat2) {
            updateSumObject.documentTotalVAT2Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT2Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT2Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (round(documentDet.itemVAT1Percentage, 2) === hrVat3) {
            updateSumObject.documentTotalVAT3Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT3Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT3Base += (parseFloat(documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (documentDet.itemBaseAmount) {
            if (parseInt(documentDet.FreeF1) === 1) {
              updateSumObject.FreeF1 += parseFloat(documentDet.itemBaseAmount)
            }
            if (parseInt(documentDet.FreeF1) === 2) {
              updateSumObject.FreeF2 += parseFloat(documentDet.itemBaseAmount)
              updateSumObject.FreeF5 += parseFloat(documentDet.empWrkHrs)
            }
            if (parseInt(documentDet.FreeF1) === 3) {
              updateSumObject.FreeF3 += parseFloat(documentDet.itemBaseAmount)
            }
          }
          if (documentDet.itemBaseAmountNoVAT) {
            if (round(parseFloat(documentDet.itemVAT1Amount),2) === 0) {
              updateSumObject.FreeF4 += parseFloat(documentDet.itemBaseAmountNoVAT)
            }
          }
          if (documentDet.itemDirectDuty1Amount) {
            updateSumObject.documentTotalAmountDirectD1+= parseFloat(documentDet.itemDirectDuty1Amount)
          }
        })
      }

      updateSumObject.documentTotalAmountNetto = updateSumObject.documentTotalAmountNetto ? round(updateSumObject.documentTotalAmountNetto, 2) : 0
      updateSumObject.documentTotalVAT1Amount  = round((updateSumObject.documentTotalVAT1Base * ( (hrVat1/100))),2)
      updateSumObject.documentTotalVAT2Amount  = round((updateSumObject.documentTotalVAT2Base * ( (hrVat2/100))),2)
      updateSumObject.documentTotalVAT3Amount  = round((updateSumObject.documentTotalVAT3Base * ( (hrVat3/100))),2)
      updateSumObject.documentDescription9 = updateSumObject.documentDescription9 ? round(updateSumObject.documentDescription9, 2) : 0
      updateSumObject.supplierNetoAmount = updateSumObject.supplierNetoAmount ? round(updateSumObject.supplierNetoAmount, 2) : 0
      updateSumObject.supplierMargin = round(updateSumObject.documentTotalAmountNetto - updateSumObject.supplierNetoAmount, 2)
      updateSumObject.documentTotalAmountVAT = updateSumObject.documentTotalVAT1Amount + updateSumObject.documentTotalVAT2Amount + updateSumObject.documentTotalVAT3Amount
      updateSumObject.documentTotalAmountBrutto = updateSumObject.documentTotalAmountNetto + updateSumObject.documentTotalAmountVAT
      updateSumObject.documentTotalVAT1Per = hrVat1 ? round(hrVat1, 2) : 0
      updateSumObject.documentTotalVAT2Per = hrVat2 ? round(hrVat2, 2) : 0
      updateSumObject.documentTotalVAT3Per = hrVat3 ? round(hrVat3, 2) : 0

      // updateSumObject.documentTotalVAT1Base = hrVat1 && updateSumObject.documentTotalVAT1Amount ? round(updateSumObject.documentTotalVAT1Amount / (hrVat1/100), 2) : 0
      // updateSumObject.documentTotalVAT2Base = hrVat2 && updateSumObject.documentTotalVAT2Amount ? round(updateSumObject.documentTotalVAT2Amount / (hrVat2/100), 2) : 0
      // updateSumObject.documentTotalVAT3Base = hrVat3 && updateSumObject.documentTotalVAT3Amount ? round(updateSumObject.documentTotalVAT3Amount / (hrVat3/100), 2) : 0
      updateSumObject.FreeF1 = updateSumObject.FreeF1 ? round(updateSumObject.FreeF1, 2) : 0
      updateSumObject.FreeF2 = updateSumObject.FreeF2 ? round(updateSumObject.FreeF2, 2) : 0
      updateSumObject.FreeF3 = updateSumObject.FreeF3 ? round(updateSumObject.FreeF3, 2) : 0
      updateSumObject.FreeF4 = updateSumObject.FreeF4 ? round(updateSumObject.FreeF4, 2) : 0
      updateSumObject.FreeF5 = updateSumObject.FreeF5 ? round(updateSumObject.FreeF5, 2) : 0
      updateSumObject.documentDescription10 = updateSumObject.documentDescription9 - updateSumObject.documentTotalAmountNetto
      updateSumObject.documentTotalAmountPayInAdvance = updateSumObject.documentTotalAmountPayInAdvance ? round(updateSumObject.documentTotalAmountPayInAdvance, 2) : 0
      updateSumObject.documentTotalAmountToPay = updateSumObject.documentTotalAmountBrutto ? (round(updateSumObject.documentTotalAmountBrutto, 2) - (updateSumObject.documentTotalAmountPayInAdvance )): 0

      updateSumObject.documentTotalAmountNettoForeign = updateSumObject.documentTotalAmountNetto ? round((updateSumObject.documentTotalAmountNetto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountVATForeign = updateSumObject.documentTotalAmountVAT ? round((updateSumObject.documentTotalAmountVAT / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountBruttoForeign = updateSumObject.documentTotalAmountBrutto ? round((updateSumObject.documentTotalAmountBrutto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountPayInAdvanceForeign = round((updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate), 2)
      updateSumObject.documentTotalAmountToPayForeign = updateSumObject.documentTotalAmountBrutto 
      updateSumObject.documentTotalAmountDirectD1Fore = updateSumObject.documentTotalAmountDirectD1 ? round((updateSumObject.documentTotalAmountDirectD1 / this.ExRate), 2) : 0
      console.log('Total dokumenta updateSumObject: ', updateSumObject);
      Object.assign(this.document, updateSumObject)
      console.log('CIjeli dokument this.document: ', this.document);

    },
    async newGoods() {
      try {
      this.document = defDocument()
      this.docName === 'ReceiptPurchase'
      if (this.$store.state.companyid) {
        this.CompanyId = await this.$store.state.companyid
        this.mainQuery.CompanyId = await this.$store.state.companyid
      }
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2026
      this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
      this.document.documentSide = this.$store.state.documentSide ? this.$store.state.documentSide : 0

      this.document.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
      this.document.email = this.$store.state.user.email ? this.$store.state.user.email : 'test@cegrupa.com'
      this.document.First = this.$store.state.user.First ? this.$store.state.user.First : 'NoFirst'
      this.document.Last = this.$store.state.user.Last ? this.$store.state.user.Last : 'NoLast'
      this.document.uservatID = this.$store.state.user.vatID ? this.$store.state.user.vatID : '12345678901'
      this.document.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.document.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
   
      this.mainQuery.documentName = 'ReceiptPurchase'
      this.document.documentName = 'ReceiptPurchase'
      this.document.documentAnalysis = 2
      this.document.documentSide = 1 
      let locDate1 = new Date()
      locDate1.getDate()
      locDate1.getMonth() + 1
      locDate1.getFullYear()
      const nrOfDays = this.$store.state.companyActiv.CompanyInvoiceDefDays ? parseInt(this.$store.state.companyActiv.CompanyInvoiceDefDays) : 15
      this.document.documentDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentTime = dayjs(new Date()).format('HH:mm')
      this.document.documentInvoiceStartDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentInvoiceEndDate = dayjs(new Date()).add(nrOfDays, 'days').format('YYYY-MM-DD')
      this.document.documentInvoiceEndPeriodDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentHomeCurrency = domacaValuta(this.$store.state.businessYear)
      this.document.documentForeignCurrency = 'EUR'
      this.document.documentExRate = tecajValute(this.$store.state.businessYear)
      const part = this.doc.prodavatelj
      console.log('1 -->> part ', part)
      this.document.partnerName = part.naziv
      this.document.partnerVATID = part.oib
      this.document.partnerCity = part.adresa.grad
      this.document.partnerStreet = part.adresa.ulica
      this.document.partnerPostcode = part.adresa.postanskiBroj
      this.document.partneremail = part.kontakt && part.kontakt.email ? part.kontakt.email : ''

      const partNew = {}
      partNew.partnerName  = this.document.partnerName 
      partNew.partnerVATID  = this.document.partnerVATID
      partNew.partnerCity  = this.document.partnerCity
      partNew.partnerStreet  = this.document.partnerStreet 
      partNew.partnerPostcode  = this.document.partnerPostcode 
      partNew.partneremail  = this.document.partneremail 

      const haveIt = await this.findByVATID(partNew)
      if (!haveIt) {
        console.log('Nemam partnera dodajem NOVOG Partnera document')
        // add new partner
        await this.addeditPartner(partNew)
        this.document.partnerId = this.partId
      }

      const lastNr = {}
      const side = 1
      lastNr.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      lastNr.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      if (side === 1 || side === 2) {
        lastNr.WareHouseId = this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1
      }
      lastNr.documentName = 'ReceiptPurchase'

      this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.document.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      
      this.document.documentId = parseInt((await DocumentService.choose(lastNr)).data.docNumber)
      console.log('this.document.documentId ', this.document.documentId)
      await this.newGoodsDetails()
      this.makeSum()

      if (this.document.documentId && this.document.documentId > 0)
        {
          this.document.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.document.documentId + '-' + (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
          this.document.WareHouseId = (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
          const whObj =  this.$store.state.warehouseState ? this.$store.state.warehouseState.find(whID => whID.WareHouseId === this.$store.state.warehousemarkid) : []
          this.document.WareHouseName = whObj && whObj.WareHouseName ? whObj.WareHouseName : ''

          await DocumentService.post(this.document)
            .then(async(response) => {
              const newDoc = response.data && response.data.newDoc ? response.data.newDoc : null
              if (newDoc && newDoc.id) {
                console.log('newDoc: ', newDoc);
                
                for (let i = 0; i < this.activItems.length; i++) {
                  Object.assign(this.activItems[i],
                   { 
                      databaseDocID: newDoc.id,
                      CompanyId: this.document.CompanyId,
                      CompanyNameDatabase: this.document.CompanyNameDatabase,
                      BusinessYear: this.document.BusinessYear,
                      UserId: this.document.UserId,
                      email: this.document.email,
                      documentName: 'ReceiptPurchase',
                      documentId: this.document.documentId,
                      documentIdGeneral: this.document.documentIdGeneral,
                      documentDate: this.document.documentDate,
                      partnerId: this.document.partnerId,
                      partnerNameDatabase: this.document.partnerNameDatabase,
                      HomeCurrency: 'EUR',
                      ForeignCurrency: 'EUR',
                      ExRate: 1,
                      ItemHomeCurrency: 'EUR',
                      ItemForeignCurrency: 'EUR',
                      ItemExRate: 1
                  });
                }
                

                await DocumentDetailService.saveitems(this.activItems).then(res => {
                  this.text = this.langC.DocumentSaved + (res && res.data && res.data.message ? res.data.message : '')
                  this.color = 'green'
                  this.snackbar = true
                }).catch(err => {
                  console.log(err)
                  this.text = 'Error post!' + err
                  this.color = 'red'
                  this.snackbar = true
                  this.timeout = 4000
                })

              }
            })
            .catch(err => {
              // eslint-disable-next-line
              console.log(err)
              this.text = 'Error post!' + err
              this.color = 'red'
              this.snackbar = true
              this.timeout = 4000
            })
        }

      } catch (error) {
       alert('Greska! Error. ' + error) 
      }
    },
    async myMethod(param) {
      try {
        this.saving = true
        console.log('param', param)
        for (var member in this.doc) delete this.doc[member];
        this.locBookID = param

        const query = {
          id: param,
          pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : '',
          companyId:  this.$store.state.companyid ? this.$store.state.companyid : 1,
          businessYear: this.$store.state.businessYear ? this.$store.state.businessYear : 2026,
          newId: this.getRndInteger(1000000000, 9000000000),
          notSaveDoc: false,
          user: this.$store.state.companyActiv.eRacunProviderUserName ? this.$store.state.companyActiv.eRacunProviderUserName : '',
          pass: this.$store.state.companyActiv.eRacunProviderUserPassword ? this.$store.state.companyActiv.eRacunProviderUserPassword : '',
          companyVATID: this.$store.state.companyActiv.CompanyVATID? this.$store.state.companyActiv.CompanyVATID: ''
        }
        let res = null
        if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 1) {
          res = await PondiService.getxml(query)
        }
        if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2) {
          res = await merService.getxml(query)
        }
        // const res = await PondiService.getxml(query)
        console.log('res', res)
        this.doc = res && res.data && res.data.invoice ? res.data.invoice : null
        if (Object.keys(this.doc).length > 0) {
          console.log('this.doc', this.doc)
          // create new Mainledger Head
          await this.newdocument()
          // // fill it with data 
          this.mainledger.filexml_originalname = this.doc.filexml_originalname
          this.mainledger.filexml_destination = this.doc.filexml_destination
          this.mainledger.filexml_fieldname = ''
          this.mainledger.filexml_filename = this.doc.filexml_filename
          this.mainledger.filexml_mimetype = this.doc.filexml_mimetype
          this.mainledger.filexml_path = this.doc.filexml_path
          this.mainledger.filexml_size = 0
          this.mainledger.filepdf_originalname = this.doc.filepdf_originalname
          this.mainledger.filepdf_destination = this.doc.filepdf_destination
          this.mainledger.filepdf_fieldname = this.doc.filepdf_fieldname
          this.mainledger.filepdf_filename = this.doc.filepdf_filename
          this.mainledger.filepdf_mimetype = this.doc.filepdf_mimetype
          this.mainledger.filepdf_path = this.doc.filepdf_path
          this.mainledger.filepdf_size = 0
          this.mainledger.MLFree2 = this.doc.filepdf_originalname ? this.doc.filepdf_originalname : ''
          this.mainledger.MLFree3 = this.doc.filepdf_filename ? this.doc.filepdf_filename : ''
          this.mainledger.MLFree4 = this.doc.filepdf_destination ? this.doc.filepdf_destination : ''
          this.mainledger.MLFree5 = this.doc.filepdf_path ? this.doc.filepdf_path : ''
          await this.fillNewDocument()
          await this.kreirajVirman()
          // update items with connected mainledger
          const nema = false
          if (this.items && this.items.length > 0) {
              this.items = this.items.map(item => {
                if (item.id === param) {
                  return { ...item, 
                    inBooks: true,
                    BookID: this.mainledger.BookID,
                    BookName: this.mainledger.BookName,
                    BookingDate: this.mainledger.BookingDate,
                    email: this.mainledger.email,
                    amount: this.mainledger.InvoiceAmount,
                    virmanId: this.mainledger.virmanId ? this.mainledger.virmanId : null,
                    paymentApproved: this.mainledger.paymentApproved === true,
                    paidClosed: this.mainledger.paidClosed === true,
                    PaymentMeansCode: this.mainledger.PaymentMeansCode
                   };
                }
                return item;
              });
          }
          const newTikTok = this.$store.state.tikTok + 1
          this.$store.dispatch('setTikTok', newTikTok)
        }
        if (Object.keys(this.doc).length === 0){
          alert('Error! Something is wrong with load data!')
        }
        this.saving = false
      } catch (error) {
        this.saving = false
        console.log('error', error)
        alert(error)
      }

    },
    // Poziv na broj s eRacuna dolazi kao "HR00 123456" ili "HR00123456".
    // Prve cetiri znamenke su model, ostatak je poziv na broj.
    razdvojiPozivNaBroj (tekst) {
      const cijeli = String(tekst || '').trim()
      if (cijeli.length === 0) { return {model: 'HR99', broj: ''} }
      const nadjen = cijeli.match(/^(HR\d{2})[\s-]*(.*)$/i)
      if (nadjen) { return {model: nadjen[1].toUpperCase(), broj: nadjen[2].trim()} }
      return {model: 'HR99', broj: cijeli}
    },

    // Placa se dan prije dospijeca, a ako to padne na vikend onda u petak.
    // Racunu kojem je rok vec prosao datum izvrsenja je danas.
    datumPlacanja (dospijece) {
      const danas = dayjs().startOf('day')
      if (!dospijece) { return danas.format('YYYY-MM-DD') }
      let dan = dayjs(dospijece).startOf('day').subtract(1, 'day')
      while (dan.day() === 6 || dan.day() === 0) { dan = dan.subtract(1, 'day') }
      if (dan.isBefore(danas)) { dan = danas }
      return dan.format('YYYY-MM-DD')
    },

    // Vlastiti racun s kojeg se placa - onaj oznacen kao zadani.
    async nasRacun () {
      if (this.virmanBanka !== null) { return this.virmanBanka }
      this.virmanBanka = false
      try {
        const upit = {CompanyId: this.$store.state.companyid, businessYear: this.$store.state.businessYear}
        const {data} = await BankAccountService.choose(upit)
        const racuni = data && data.bankAccounts ? data.bankAccounts : []
        this.virmanBanka = racuni.find(racun => racun.DefaultAccount === true) || racuni[0] || false
      } catch (err) {
        this.virmanBanka = false
      }
      return this.virmanBanka
    },

    // Vec postojeci virmani za ulazne racune - da se isti racun ne plati dvaput.
    async postojeciVirmani () {
      if (this.virmaniPostojeci !== null) { return this.virmaniPostojeci }
      this.virmaniPostojeci = new Set()
      try {
        const upit = {CompanyId: this.$store.state.companyid, businessYear: this.$store.state.businessYear, FreeF5: 'URA'}
        const {data} = await BankOrderService.index(upit)
        const virmani = data && data.bankorders ? data.bankorders : []
        virmani.forEach(virman => { this.virmaniPostojeci.add(this.kljucVirmana(virman.PrimateljIBAN, virman.Iznos, virman.Opis1)) })
      } catch (err) {
        this.virmaniPostojeci = new Set()
      }
      return this.virmaniPostojeci
    },

    kljucVirmana (iban, iznos, opis) {
      return String(iban || '').replace(/\s/g, '').toUpperCase() + '|' + round(parseNum(iznos), 2) + '|' + String(opis || '').trim()
    },

    // Kod dijela partnera ulica vec sadrzi kucni broj, a grad postanski broj,
    // pa se takav dodatak ne lijepi drugi put.
    adresaUlica (ulica, kucniBroj) {
      const a = String(ulica || '').trim()
      const b = String(kucniBroj || '').trim()
      if (a.length === 0) { return b }
      if (b.length === 0) { return a }
      if (a.split(/\s+/).some(rijec => /\d/.test(rijec))) { return a }
      return a + ' ' + b
    },

    adresaGrad (postanskiBroj, grad) {
      const a = String(postanskiBroj || '').trim()
      const b = String(grad || '').trim()
      if (a.length === 0) { return b }
      if (b.length === 0) { return a }
      if (b.split(/\s+/)[0] === a) { return b }
      return a + ' ' + b
    },

    javiVirman (poruka, boja) {
      this.virmaniPreskoceni.push(poruka)
      this.text = poruka
      this.color = boja
      this.timeout = boja === 'green' ? 4000 : 6000
      this.snackbar = true
    },

    // Uz ucitani ulazni racun odmah se stvara i virman za placanje.
    async kreirajVirman () {
      const ml = this.mainledger
      const oznaka = (ml.BookName ? ml.BookName + ' ' : '') + (parseInt(ml.BookID) || '') + (ml.partnerName ? ', ' + ml.partnerName : '')
      if (parseInt(ml.BookTypeID) >= 10) { return }
      const nacin = nacinIzSifre(ml.PaymentMeansCode)
      if (ml.paidClosed === true || !nacin.virman) {
        const razlog = ml.paidClosed === true
          ? 'račun je plaćen (' + nacin.naziv.toLowerCase() + ')'
          : nacin.naziv.toLowerCase() + ' - banka tereti sama'
        this.javiVirman(oznaka + ' - virman nije potreban, ' + razlog, 'blue')
        return
      }
      const iznos = round(parseNum(ml.InvoiceAmount), 2)
      const iban = String(ml.partnerBankIBAN || '').replace(/\s/g, '').toUpperCase()
      if (iban.length === 0) {
        this.javiVirman(oznaka + ' - virman nije napravljen, račun nema IBAN dobavljača', 'red')
        return
      }
      if (iznos <= 0) {
        this.javiVirman(oznaka + ' - virman nije napravljen, iznos računa je ' + iznos, 'red')
        return
      }
      const banka = await this.nasRacun()
      if (!banka) {
        this.javiVirman(oznaka + ' - virman nije napravljen, firma nema upisan žiro račun', 'red')
        return
      }
      const opis1 = ('Račun ' + (ml.InvoiceNumber ? ml.InvoiceNumber : '')).trim().substring(0, 35)
      const kljuc = this.kljucVirmana(iban, iznos, opis1)
      const postojeci = await this.postojeciVirmani()
      if (postojeci.has(kljuc)) {
        this.javiVirman(oznaka + ' - virman za ovaj račun već postoji', 'blue')
        return
      }
      try {
        const noviVirman = {...defBankOrder(), ...defNewBankOrder()}
        const datum = this.datumPlacanja(ml.InvoicePaymentDeadlineDate)
        noviVirman.salarieID = 0
        noviVirman.Order = 0
        noviVirman.Month = parseInt(dayjs(datum).format('M'))
        noviVirman.Year = parseInt(dayjs(datum).format('YYYY'))
        noviVirman.PlatiteljIBAN = banka.IBAN
        // HR99 znaci "bez poziva na broj" i uz njega poziv mora ostati prazan -
        // banka takvu datoteku potpise pa je odbije. HR00 je model bez
        // kontrolne znamenke, pa broj knjizenja smije ostati kao oznaka po
        // kojoj se uplata prepozna na izvodu.
        const pozivPlatitelja = String(parseInt(ml.BookID) || '')
        noviVirman.PlatiteljModel = pozivPlatitelja ? 'HR00' : 'HR99'
        noviVirman.PlatiteljPoziv = pozivPlatitelja
        noviVirman.bankAccountId = String(banka.id)
        noviVirman.bankAccountName = banka.BankName
        noviVirman.bankAccountNr = banka.IBAN
        noviVirman.DatumIzvrsenja = datum
        // opis placanja s eRacuna zna biti dugacak tekst - u virman ide samo ako stane
        const opisSRacuna = String(ml.PayDesc || '').split(/[\r\n]/)[0].trim()
        noviVirman.Opis1 = opis1
        noviVirman.Opis2 = opisSRacuna.length > 0 && opisSRacuna.length <= 35 ? opisSRacuna : ''
        noviVirman.Iznos = iznos
        noviVirman.Primatelj1 = ml.partnerName ? ml.partnerName : ''
        noviVirman.Primatelj2 = this.adresaUlica(ml.partnerStreet, ml.partnerBuildingNameNumber)
        noviVirman.Primatelj3 = this.adresaGrad(ml.partnerPostcode, ml.partnerCity)
        noviVirman.PrimateljIBAN = iban
        noviVirman.PrimateljModel = ml.Pay1 ? ml.Pay1 : 'HR99'
        noviVirman.PrimateljPoziv = ml.Pay2 ? ml.Pay2 : ''
        noviVirman.Grupa = 2
        noviVirman.Hitno = false
        noviVirman.FreeF1 = parseInt(ml.BookID) || 0
        noviVirman.FreeF5 = 'URA'
        const snimljen = await BankOrderService.post(noviVirman)
        const virmanId = snimljen && snimljen.data && snimljen.data.bankorder ? snimljen.data.bankorder.id : null
        if (virmanId) {
          // veza racun -> virman, da se u listi vidi kvacica
          this.mainledger.virmanId = virmanId
          await MainLedgerService.put(this.mainledger)
        }
        postojeci.add(kljuc)
        this.virmaniKreirani += 1
        this.javiVirman('Virman ' + iznos + ' EUR, plaćanje ' + dayjs(datum).format('DD.MM.YYYY') + ' - ' + noviVirman.Primatelj1, 'green')
      } catch (err) {
        this.javiVirman(oznaka + ' - greška kod spremanja virmana', 'red')
      }
    },

    async newdocument () {
      try {
        if (this.$store.state.bookTypeSelected) {

          this.mainledger = defMainLedger()
          this.mainledger = {...this.mainledger, ...defNew()}
          this.mainQuery = {...defMainQuery()}

          this.mainledger.BookID = parseInt((await MainLedgerService.choose(this.mainQuery)).data.docNumber)
          this.mainledger.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.mainledger.BookID 

          await this.$store.dispatch('setMainLedgerActiv', {})
          console.log('this.$store.state.bookTypeSelected', this.$store.state.bookTypeSelected)

          if (this.$store.state.bookTypeSelected && this.$store.state.bookTypeSelected.value) {
            this.mainledger.BookTypeID = parseInt(this.$store.state.bookTypeSelected.value)
            this.mainledger.BookName = this.$store.state.bookTypeSelected.text

            if (this.mainledger.BookID === 0) {
              this.mainledger.BookID = (await MainLedgerService.choose(this.mainQuery)).data.docNumber
            }

            this.mainledger.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.mainledger.BookID 

            await MainLedgerService.post(this.mainledger)
            .then(res => {
              this.savedML = res.data.mainledger ? res.data.mainledger : {}
              this.mainledger = res.data.mainledger ? {...res.data.mainledger} : {}
              this.$store.dispatch('setMainLedgerid', this.savedML.id)
              this.$store.dispatch('setMainLedgerActiv', this.savedML ? this.savedML : {})
              this.locBookID = parseInt(this.savedML.BookID)
            })
            .catch(err => {
              this.error = err.data
              this.text = 'Error1! Cannot save document to database. ' + err
              this.color = 'red'
              this.snackbar = true
            })
          } else {
            this.text = 'Greska! Nije odabrana vrsta knjige!!'
            this.color = 'red'
            this.snackbar = true
          }
          
        } else {
          this.text = this.lang.BookTypeNotSelected
          this.color = 'red'
          this.snackbar = true
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async fillNewDocument() {
      this.mainledger.InvoiceNumber = this.doc.broj
      this.mainledger.InvoiceDate = this.doc.datum
      this.mainledger.InvoicePaymentDeadlineDate = null
      this.mainledger.BookingDate = this.doc.datumZaPDV
      this.mainledger.InvoicePaymentDeadlineDate = this.doc.rokPlacanja ? this.doc.rokPlacanja : this.doc.rokplacanja
      console.log('0 --> this.$store.state.documentSide: ', this.$store.state.documentSide);
      let part = null
      if (this.$store.state.documentSide === 1) {
        part = this.doc.prodavatelj
      }
      if (this.$store.state.documentSide === 2) {
        part = this.doc.kupac
      }
      console.log('1 -->> part ', part)
      this.mainledger.partnerName = part.naziv
      this.mainledger.partnerVATID = part.oib
      this.mainledger.partnerCity = part.adresa.grad
      this.mainledger.partnerStreet = part.adresa.ulica
      this.mainledger.partnerPostcode = part.adresa.postanskiBroj
      this.mainledger.partneremail = part.kontakt && part.kontakt.email ? part.kontakt.email : ''

      const partNew = {}
      partNew.partnerName  = this.mainledger.partnerName 
      partNew.partnerVATID  = this.mainledger.partnerVATID
      partNew.partnerCity  = this.mainledger.partnerCity
      partNew.partnerStreet  = this.mainledger.partnerStreet 
      partNew.partnerPostcode  = this.mainledger.partnerPostcode 
      partNew.partneremail  = this.mainledger.partneremail

      const haveIt = await this.findByVATID(partNew)
      if (!haveIt) {
        console.log('Nemam partnera dodajem NOVOG Partnera')
        // add new partner
        await this.addeditPartner(partNew)
        this.mainledger.partnerId = this.partId
      }

      // ----------------------------------------------------- Novci
      // Iznos racuna je iznos s PDV-om. Kod racuna placenih karticom ili gotovinom
      // dobavljac stavlja cijeli iznos u PrepaidAmount, a PayableAmount je nula -
      // zato se ne smije uzeti "zaUplatu".
      const iznosRacuna = this.doc.ukupno.sPdvom && parseNum(this.doc.ukupno.sPdvom) > 0
        ? this.doc.ukupno.sPdvom
        : this.doc.ukupno.zaUplatu
      this.mainledger.InvoiceAmount = iznosRacuna
      this.mainledger.InvoiceForeginAmount = iznosRacuna
      
      // ---- virman  
      // Podaci za placanje s eRacuna - iz njih se slaze virman.
      const InstructionNote = this.doc.placanje.opis ? this.doc.placanje.opis : (this.doc.placanje.opisPlacanja ? this.doc.placanje.opisPlacanja : '') // opis placanja
      const PaymentID = this.doc.placanje.pozivNaBroj  // poziv na broj HR00 123456
      this.mainledger.partnerBankIBAN = this.doc.placanje.iban
      // Nacin placanja dolazi s eRacuna; gotovina i kartica znace da je vec placen.
      this.mainledger.PaymentMeansCode = this.doc.placanje.sifra ? String(this.doc.placanje.sifra).trim() : ''
      if (vecPodmiren(this.mainledger.PaymentMeansCode, iznosRacuna, this.doc.ukupno.placeno)) {
        this.mainledger.paidClosed = true
        this.mainledger.paidDate = this.doc.datum
        this.mainledger.paidHome = round(parseNum(iznosRacuna), 2)
      }
      const pozivNaBroj = this.razdvojiPozivNaBroj(PaymentID)
      this.mainledger.Pay1 = pozivNaBroj.model
      this.mainledger.Pay2 = pozivNaBroj.broj
      this.mainledger.PayDesc = InstructionNote

       if (this.$store.state.companyActiv.notinVAT=== false) { 
          if (Array.isArray(this.doc.poreziDetaljno)){
            // ima vise poreznih stopa
            this.doc.poreziDetaljno.map(tax => {
              const taxVATPer = parseNum(tax.postotak,2)
              const TaxAmount = parseNum(tax.iznosPoreza,2)
              const TaxableAmount = parseNum(tax.osnovica,2)

              if (taxVATPer === 25) {
                this.mainledger.VAT1Amount = round(TaxAmount,2)
                this.mainledger.VAT1PerCanUse = 100
                this.mainledger.VAT1CanUse = round(TaxAmount,2)
                this.mainledger.VAT1CanTUse = 0
                this.mainledger.VAT1Base = round(TaxableAmount ,2)
              }
              if (taxVATPer === 13) {
                this.mainledger.VAT2Amount = round(TaxAmount,2)
                this.mainledger.VAT2PerCanUse = 100
                this.mainledger.VAT2CanUse = round(TaxAmount,2)
                this.mainledger.VAT2CanTUse = 0
                this.mainledger.VAT2Base = round(TaxableAmount ,2)
              }
              if (taxVATPer === 5) {
                this.mainledger.VAT3Amount = round(TaxAmount,2)
                this.mainledger.VAT3PerCanUse = 100
                this.mainledger.VAT3CanUse = round(TaxAmount,2)
                this.mainledger.VAT3CanTUse = 0
                this.mainledger.VAT3Base = round(TaxableAmount ,2)
              }
              if (taxVATPer === 0) {
                this.mainledger.VAT4Base = round(TaxableAmount,2)
              }
            })
          }
          // if (!Array.isArray(taxSubtotal)){
          //   // ima jednu poreznu stopu
          //   const taxCategory = taxSubtotal['cac:TaxCategory']
          //   const taxVATPer = taxCategory['cbc:Percent']
          //   const TaxAmount = taxSubtotal['cbc:TaxAmount']
          //   const TaxableAmount = taxSubtotal['cbc:TaxableAmount']
          //   if (taxVATPer === 25) {
          //     this.mainledger.VAT1Amount = round(TaxAmount,2)
          //     this.mainledger.VAT1PerCanUse = 100
          //     this.mainledger.VAT1CanUse = round(TaxAmount,2)
          //     this.mainledger.VAT1CanTUse = 0
          //     this.mainledger.VAT1Base = round(TaxableAmount ,2)
          //   }
          //   if (taxVATPer === 13) {
          //     this.mainledger.VAT2Amount = round(TaxAmount,2)
          //     this.mainledger.VAT2PerCanUse = 100
          //     this.mainledger.VAT2CanUse = round(TaxAmount,2)
          //     this.mainledger.VAT2CanTUse = 0
          //     this.mainledger.VAT2Base = round(TaxableAmount ,2)
          //   }
          //   if (taxVATPer === 5) {
          //     this.mainledger.VAT3Amount = round(TaxAmount,2)
          //     this.mainledger.VAT3PerCanUse = 100
          //     this.mainledger.VAT3CanUse = round(TaxAmount,2)
          //     this.mainledger.VAT3CanTUse = 0
          //     this.mainledger.VAT3Base = round(TaxableAmount ,2)
          //   }
          // }
        }
        console.log('this.mainledger PUT ', this.mainledger)
        await this.calculateVATAmount()
        await this.updateMl()
    },
    async updateMl() {
      try {
        await MainLedgerService.put(this.mainledger).then(res => {
          this.mainledger = Object.assign({}, res.data.newDoc)
          this.text = 'Dokument je snimljen' + res.data.message
          this.color = 'green'
          this.snackbar = true
          
        }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
        })         
      } catch (error) {
        this.text = 'Error ' + error
        this.color = 'red'
        this.snackbar = true
      }
    },
    onUploadPDF() {
      if (this.somefile && this.somefile.type === 'application/pdf') {
        const newId = this.getRndInteger(100000, 900000)
        let fd = new FormData()
        fd.append('companyId', this.$store.state.companyid)
        fd.append('newId', newId)
        fd.append('originalName', this.somefile.name)
        fd.append('typeDoc', 'BI')
        fd.append('myFile', this.somefile, this.somefile.name)
        Api().post('bookin/invoice', fd).then(response => {
            this.data = response.data
             if (this.data) {
                this.mainledger.MLFree2 = this.data.originalname ? this.data.originalname : ''
                this.mainledger.MLFree3 = this.data.filename ? this.data.filename : ''
                this.mainledger.MLFree4 = this.data.destination ? this.data.destination : ''
                this.mainledger.MLFree5 = this.data.path ? this.data.path : ''
                this.havePDF = true
                this.updateMl()
            }
        }).catch(error => {
            this.text = 'Error ' + error
            this.color = 'red'
            this.snackbar = true
            if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
            }
        });
      } else {

      }
    },
    calculateVATAmount () {
      this.mainledger.AmountVAT = ((parseNum(this.mainledger.VAT1Amount,2) + parseNum(this.mainledger.VAT2Amount,2) + parseNum(this.mainledger.VAT3Amount,2)))
      this.mainledger.AmountNetto = ((parseNum(this.mainledger.InvoiceAmount,2) - parseNum(this.mainledger.AmountVAT,2) - parseNum(this.mainledger.VAT4Base,2)))
    },
    async findByVATID(part) {
      if (part.partnerVATID) {
        const query = {}
        query.CompanyId = this.$store.state.companyid
        query.partnerVATID = part.partnerVATID

        const {data} = await PartnerService.check(query)
        console.log('partner by vatid data: ', data);
        const id = data && data.partner && data.partner.id ? data.partner.id : null
        if (id) {

          return true
        }
        if (!id) {

          return false
        }
      }
    },
    async findPartner () {
      console.log('4 FIND partner this.mainledger.partnerVATID: ', this.mainledger.partnerVATID);
      if (this.mainledger && this.mainledger.partnerVATID) {
        
        const locPartner = (await PartnerService.show(this.mainledger.partnerVATID)).data.partner
        console.log('5 --> locPartner: ', locPartner);
        this.mainledger.partnerId = locPartner.id
        this.mainledger.partnerName = locPartner.partnerName
        this.mainledger.partnerNameShort = locPartner.partnerNameShort
        this.mainledger.partnerNameDatabase = locPartner.partnerNameDatabase
        this.mainledger.partnerBuildingNameNumber = locPartner.partnerBuildingNameNumber
        this.mainledger.partnerStreet = locPartner.partnerStreet
        this.mainledger.partnerCity = locPartner.partnerCity
        this.mainledger.partnerPostcode = locPartner.partnerPostcode
        this.mainledger.partnerCountyRegion = locPartner.partnerCountyRegion
        this.mainledger.partnerState = locPartner.partnerState
        this.mainledger.partnerVATID = locPartner.partnerVATID
        this.mainledger.partneremail = locPartner.partneremail
        this.mainledger.partnerPhones = locPartner.partnerPhones
        this.mainledger.partnerBankName = locPartner.partnerBankName
        this.mainledger.partnerBankAddress = locPartner.partnerBankAddress
        this.mainledger.partnerBankIBAN = locPartner.partnerBankIBAN
        this.mainledger.partnerBankSWIFT = locPartner.partnerBankSWIFT
      }
    },
    async addeditPartner (part) {
        console.log('part.partnerVATID: ', part.partnerVATID);
        part.partnerVATID = part && part.partnerVATID && typeof part.partnerVATID === 'string' ? part.partnerVATID.trim() : ( part.partnerVATID && typeof part.partnerVATID !== 'string' ? part.partnerVATID.toString().trim(): null)
        part.partnerName = part.partnerName ? part.partnerName.trim() : null
        if (!part.partnerName || part.partnerName.length === 0) {
          this.text = 'Partner nema ime! Partner name is not defined!'
          this.color = 'red'
          this.snackbar = true
          return
        }
        if (!part.partnerVATID || part.partnerVATID.trim().length === 0) {
          this.text = 'Partner nema OIB! Partner VAT ID is not defined!'
          this.color = 'red'
          this.snackbar = true
          return
        }
        // if (!this.mainledger.partneremail || this.mainledger.partneremail.trim().length === 0) {
        //   this.text = 'Partner nema email! Partner email is not defined!'
        //   this.color = 'red'
        //   this.snackbar = true
        //   return
        // }
        const addeditPartner = {...defNewpartner()}

        addeditPartner.CompanyId = this.$store.state?.companyid ?? 0
        addeditPartner.CompanyNameDatabase = this.$store.state?.companyName ?? ''
        addeditPartner.BusinessYear = this.$store.state?.businessYear ?? new Date().getFullYear()
        addeditPartner.UserId = this.$store.state?.UserId ?? 1
        addeditPartner.email = this.$store.state?.email ?? 'test@cegrupa.com'
        addeditPartner.First = this.$store.state?.First ?? 'NoFirst'
        addeditPartner.Last = this.$store.state?.Last ?? 'NoLast'
        addeditPartner.partnerName = part.partnerName
        addeditPartner.partnerNameShort = part.partnerName.replace(/[\W_]/g, '')
        addeditPartner.partnerNameDatabase = part.partnerName.replace(/[\W_]/g, '')
        addeditPartner.partnerBuildingNameNumber = part?.partnerBuildingNameNumber ?? '';
        addeditPartner.partnerStreet = part?.partnerStreet ?? '';
        addeditPartner.partnerCity = part?.partnerCity ?? '';
        addeditPartner.partnerPostcode = part?.partnerPostcode ?? '';
        addeditPartner.partnerCountyRegion = part?.partnerCountyRegion ?? '';
        addeditPartner.partnerState = part?.partnerState ?? '';
        addeditPartner.partnerVATID = part?.partnerVATID ?? '';
        addeditPartner.partneremail = part?.partneremail ?? '';
        this.saving = true
        console.log('saving: new partner ', addeditPartner);

        const newPartner = await PartnerService.post(addeditPartner)
        this.partId = newPartner.data.partner.id ? newPartner.data.partner.id : null
        const privateP = this.$store.state.user ? this.$store.state.user.privatePartner : true
        if (privateP) {
          const newPrivatePartner = {}
          newPrivatePartner.CompanyId = newPartner.data.partner.CompanyId
          newPrivatePartner.CompanyNameDatabase = newPartner.data.partner.CompanyNameDatabase
          newPrivatePartner.BusinessYear = newPartner.data.partner.BusinessYear
          newPrivatePartner.UserId = newPartner.data.partner.UserId ? newPartner.data.partner.UserId : ''
          newPrivatePartner.email = newPartner.data.partner.email ? newPartner.data.partner.email : ''
          newPrivatePartner.partnerId = newPartner.data.partner.id ? newPartner.data.partner.id : ''
          newPrivatePartner.partnerNameDatabase = newPartner.data.partner.partnerNameDatabase ? newPartner.data.partner.partnerNameDatabase : ''
          newPrivatePartner.partnerVATID = newPartner.data.partner.partnerVATID ? newPartner.data.partner.partnerVATID : ''
          await PartnerCompanyService.post(newPrivatePartner)
        }
        this.text = this.lang.Partneradded
        this.color = 'green'
        this.snackbar = true
        this.timeout = 2000
        await newUpdates(2)
        await testLastUpdate()
        if (this.$store.state.partnerStore) {
          this.partners = this.$store.state.partnerStore
        }
           
        this.saving = false
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    localDate(dateToFormat) {
       return dateFormat(dateToFormat)
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async loadEinvoices() {
        try {
          this.items.length = 0
          this.total = 0
          const diffDays = dayjs(this.endDate).diff(this.startDate, 'day')
          if (diffDays > 31 ){
            throw new Error("Error! Max umber of days! Greška! Predugački period!");
          }
          this.saving = true
          this.showCard1 = false
          if (this.$store.state.companyid) {
            this.mainQuery.CompanyId = this.$store.state.companyid
          }
          if (this.$store.state.businessYear) {
            this.mainQuery.businessYear = this.$store.state.businessYear
          }
          if (this.$store.state.documentSide) {
            this.mainQuery.MLType = this.$store.state.documentSide
          }

          this.bookItems.length = 0
          const {data} = await MainLedgerService.index(this.mainQuery)
          if (data && data.documents !== undefined && data.documents.length > 0) {
            this.bookItems = data.documents
          }
          const lenItems = this.bookItems && this.bookItems.length > 0 ? this.bookItems.length : 0

          const query = {
              fromDate: this.startDate ? this.startDate : null,
              toDate: this.endDate ? this.endDate : null,
              pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : '',
              user: this.$store.state.companyActiv.eRacunProviderUserName ? this.$store.state.companyActiv.eRacunProviderUserName : '',
              pass: this.$store.state.companyActiv.eRacunProviderUserPassword ? this.$store.state.companyActiv.eRacunProviderUserPassword : '',
              companyVATID: this.$store.state.companyActiv.CompanyVATID? this.$store.state.companyActiv.CompanyVATID: ''
          }
          let res = null
          if (this.$store.state.documentSide === 1) {
            if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 1) {
              res = await PondiService.getulazni(query)
            }
            if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2) {
              res = await merService.getulazni(query)
            }

          }
          if (this.$store.state.documentSide === 2) {
            if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 1) {
              res = await PondiService.getizlazni(query)
            }
            if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2) {
              res = await merService.getizlazni(query)
            }
            
           
          }
          
           console.log('query: ', query);
          console.log('res: ', res);
          if (res && res.data) {
            // ako je iz pondija
             if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 1) {
              res.data.map(itm => {
                const newItm = {...itm}
                newItm.inBooks = false
                newItm.BookID = null
                newItm.supplierPartyNameShort = itm.supplierPartyName ? itm.supplierPartyName.substring(0, 25) : ''
                this.total += itm.amount

                if (this.bookItems && this.bookItems.length > 0) {
                    let haveInBooks = {}

                    for(let i = 0; i < lenItems; i++) {
                      if (this.$store.state.documentSide === 1 && this.bookItems[i].InvoiceNumber === itm.documentId && this.bookItems[i].partnerVATID === itm.supplierPartyVATId) {
                        haveInBooks = this.bookItems[i]
                        break
                      }
                      if (this.$store.state.documentSide === 2 && this.bookItems[i].InvoiceNumber === itm.documentId && this.bookItems[i].partnerVATID === itm.customerPartyVATId) {
                        haveInBooks = this.bookItems[i]
                        break
                      }
                  }
            
                  if (Object.keys(haveInBooks).length > 0) {
                    
                    newItm.inBooks = true
                    newItm.BookID = haveInBooks.BookID
                    newItm.BookName = haveInBooks.BookName
                    newItm.BookingDate = haveInBooks.BookingDate
                    newItm.email = haveInBooks.email
                    newItm.virmanId = haveInBooks.virmanId ? haveInBooks.virmanId : null
                    newItm.paymentApproved = haveInBooks.paymentApproved === true
                    newItm.paidClosed = haveInBooks.paidClosed === true
                    newItm.PaymentMeansCode = haveInBooks.PaymentMeansCode
                  
                  }
                }
                this.items.push(newItm)
              })
           }

            // ako je iz merA
             if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2) {

              const errorMessage = res?.data?.data?.Username?.Messages?.[0];

              if (errorMessage) {
                  throw new Error(`MER Error: ${errorMessage}`);
              }

              res.data.data.map(itm => {
                const newItm = {...itm}
                newItm.inBooks = false
                newItm.BookID = null
                newItm.supplierPartyNameShort = itm.SenderBusinessName?.slice(0, 25) || ''
                newItm.documentType = itm?.DocumentTypeId || ''
                newItm.amount = null
                newItm.documentId = itm?.DocumentNr || ''
                newItm.supplierPartyVATId = itm?.SenderBusinessNumber || ''
                newItm.customerPartyName = itm?.RecipientBusinessName || ''
                newItm.customerPartyVATId = itm?.RecipientBusinessNumber || ''
                newItm.issuedOn = itm?.Sent || ''
                newItm.insertedOn = itm?.Delivered || ''
                newItm.modifiedOn = itm?.Updated || ''
                newItm.documentType = itm.DocumentTypeId === 1 ? 'Invoice' : ''
                newItm.id = itm?.ElectronicId || '' 
                this.total += 0

                if (this.bookItems && this.bookItems.length > 0) {
                    let haveInBooks = {}

                    for(let i = 0; i < lenItems; i++) {
                      if (this.$store.state.documentSide === 1 && this.bookItems[i].InvoiceNumber === itm.DocumentNr && this.bookItems[i].partnerVATID === itm.SenderBusinessNumber) {
                        haveInBooks = this.bookItems[i]
                        break
                      }
                      if (this.$store.state.documentSide === 2 && this.bookItems[i].InvoiceNumber === itm.DocumentNr && this.bookItems[i].partnerVATID === itm.RecipientBusinessNumber) {
                        haveInBooks = this.bookItems[i]
                        break
                      }
                  }
            
                  if (Object.keys(haveInBooks).length > 0) {
                    newItm.inBooks = true
                    newItm.BookID = haveInBooks.BookID
                    newItm.BookName = haveInBooks.BookName
                    newItm.BookingDate = haveInBooks.BookingDate
                    newItm.email = haveInBooks.email
                    newItm.virmanId = haveInBooks.virmanId ? haveInBooks.virmanId : null
                    newItm.paymentApproved = haveInBooks.paymentApproved === true
                    newItm.paidClosed = haveInBooks.paidClosed === true
                    newItm.PaymentMeansCode = haveInBooks.PaymentMeansCode
                    if (this.$store.state.companyActiv.eRacunProvider && this.$store.state.companyActiv.eRacunProvider === 2) {
                      newItm.amount = haveInBooks.InvoiceAmount
                    }
                  }
                }
                this.items.push(newItm)
              })
           }


            this.total = round(this.total, 2)
            this.showCard1 = true
          }
          this.saving = false
        } catch (error) {
            this.error = error
            this.saving = false
            alert(error)
        }
    }


  },
  watch: {
    'selectedMonth' () {
     if  (this.selectedMonth) {
       let y = this.$store.state.businessYear
       let m = this.selectedMonth - 1;
       let firstDay = new Date(y, m, 1);
       let lastDay = new Date(y, m + 1, 0);

      this.startDate = dayjs(firstDay).format('YYYY-MM-DD')
      this.endDate = dayjs(lastDay).format('YYYY-MM-DD')

     }
     if (!this.selectedMonth) {
      this.startDate = dayjs([this.mainledgerAna.BusinessYear]).startOf('month').format('YYYY-MM-DD')
      this.endDate = dayjs([this.mainledgerAna.BusinessYear]).endOf('month').format('YYYY-MM-DD')
     }
   },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>
